import { render, staticRenderFns } from "./ComList.vue?vue&type=template&id=16b24843&"
import script from "./ComList.vue?vue&type=script&lang=js&"
export * from "./ComList.vue?vue&type=script&lang=js&"
import style0 from "./ComList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports